import React from "react";

import * as Styled from "./Header.styled";

export const Header: React.FC<
  Pick<React.ComponentPropsWithRef<"div">, "className"> & {
    title: string;
  }
> = ({ className, title }) => {
  return <Styled.HeaderText className={className}>{title}</Styled.HeaderText>;
};
